import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import routingNumberHelpImg from 'assets/images/routing_number_help.png';
import RedButton from 'components/buttons/RedButton';
import { H4 } from 'components/typography/Headers';
import { Text1, Text1Bold } from 'components/typography/Texts';
import ContactSupportButton from 'features/my-profile/become-fundraiser/form/components/ContactSupportButton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 395px;
  text-align: center;
  align-items: center;
`;

const Header = styled(H4)`
  margin-bottom: 24px;
`;

const HelpImg = styled.img`
  width: 350px;
  margin: 24px 0;
`;

const BackButton = styled(RedButton)`
  margin-top: 24px;
`;

interface Props {
  onClose: () => void;
}

const RoutingNumberHelpPopup = ({ onClose }: Props) => {
  const { t } = useTranslation('myProfile');

  return (
    <Container data-testid='routing-number-help-popup'>
      <Header>{t('become-fundraiser.routing-number-help.header')}</Header>
      <Text1>{t('become-fundraiser.routing-number-help.description')}</Text1>
      <HelpImg src={routingNumberHelpImg} alt={'routing number help image'} />
      <Text1Bold>{t('become-fundraiser.routing-number-help.routing-number')}</Text1Bold>
      <Text1>{t('become-fundraiser.routing-number-help.info')}</Text1>
      <ContactSupportButton />
      <BackButton onClick={onClose}>{t('become-fundraiser.routing-number-help.back-button')}</BackButton>
    </Container>
  );
};

export default RoutingNumberHelpPopup;
